import React from 'react'

interface CardProps {
  className?: string
  id?: string
  children: React.ReactNode
}
const Card: React.FC<CardProps> = ({ children, className, id }) => {
  return (
    <div id={id} className={`shadow rounded-md bg-white ${className || ''}`}>
      {children}
    </div>
  )
}

export default Card
